(() => {
  const roots = document.querySelectorAll('[data-swm26-events]');
  if (!roots.length) return;

  const getVisibleCount = () => {
    if (window.innerWidth <= 749) return 1;
    if (window.innerWidth <= 989) return 2;
    if (window.innerWidth <= 1199) return 3;
    return 4;
  };

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const debounce = (fn, delay) => {
    let t;
    return (...args) => {
      window.clearTimeout(t);
      t = window.setTimeout(() => fn(...args), delay);
    };
  };

  const initTilt = (root) => {
    const cards = root.querySelectorAll('.swm26-events__card');

    cards.forEach((card) => {
      const media = card.querySelector('.swm26-events__card-media');
      if (!media) return;

      let raf = null;

      const reset = () => {
        card.style.setProperty('--swm26-tilt-x', '0deg');
        card.style.setProperty('--swm26-tilt-y', '0deg');
        card.style.setProperty('--swm26-gloss-x', '0px');
        card.style.setProperty('--swm26-gloss-y', '0px');
        card.style.setProperty('--swm26-gloss-opacity', '0');
      };

      const update = (event) => {
        const rect = media.getBoundingClientRect();
        const px = (event.clientX - rect.left) / rect.width;
        const py = (event.clientY - rect.top) / rect.height;

        const rotateY = (px - 0.5) * 10;
        const rotateX = (0.5 - py) * 10;

        const glossX = (px - 0.5) * 30;
        const glossY = (py - 0.5) * 30;

        card.style.setProperty('--swm26-tilt-x', `${rotateX}deg`);
        card.style.setProperty('--swm26-tilt-y', `${rotateY}deg`);
        card.style.setProperty('--swm26-gloss-x', `${glossX}px`);
        card.style.setProperty('--swm26-gloss-y', `${glossY}px`);
        card.style.setProperty('--swm26-gloss-opacity', '1');
      };

      card.addEventListener('mousemove', (event) => {
        if (window.innerWidth <= 989) return;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => update(event));
      });

      card.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 989) return;
        card.style.setProperty('--swm26-gloss-opacity', '1');
      });

      card.addEventListener('mouseleave', () => {
        if (raf) cancelAnimationFrame(raf);
        reset();
      });

      card.addEventListener('blur', reset);
      reset();
    });
  };

  roots.forEach((root) => {
    const viewport = root.querySelector('[data-events-viewport]');
    const track = root.querySelector('[data-events-track]');
    const slides = Array.from(root.querySelectorAll('[data-events-slide]'));
    const prevBtn = root.querySelector('[data-events-prev]');
    const nextBtn = root.querySelector('[data-events-next]');

    if (!viewport || !track || !slides.length) return;

    let index = 0;

const getStep = () => {
  const firstSlide = slides[0];
  if (!firstSlide) return 0;

  const slideWidth = firstSlide.offsetWidth;
  const trackStyles = window.getComputedStyle(track);
  const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0');

  return Math.round(slideWidth + gap);
};

    const getMaxIndex = () => Math.max(0, slides.length - getVisibleCount());

const updateVisibility = () => {
  if (window.innerWidth <= 749) {
    slides.forEach((slide) => {
      slide.classList.add('is-visible');
      slide.classList.remove('is-leaving-left','is-leaving-right');
    });
    return;
  }

  const visibleCount = getVisibleCount();
  const start = index;
  const end = index + visibleCount - 1;

  slides.forEach((slide,i) => {

    if (i >= start && i <= end) {
      slide.classList.add('is-visible');
      slide.classList.remove('is-leaving-left','is-leaving-right');
    } else {

      if (slide.classList.contains('is-visible')) {
        slide.classList.remove('is-visible');

        if (i < start) {
          slide.classList.add('is-leaving-left');
        } else {
          slide.classList.add('is-leaving-right');
        }
      }

    }

  });
};

    const update = () => {
      if (window.innerWidth <= 749) {
        track.style.transform = 'translate3d(0, 0, 0)';
        if (prevBtn) prevBtn.disabled = true;
        if (nextBtn) nextBtn.disabled = true;
        updateVisibility();
        return;
      }

      const maxIndex = getMaxIndex();
      index = clamp(index, 0, maxIndex);
      const step = getStep();
      const offset = step * index;

      track.style.transform = `translate3d(${-offset}px, 0, 0)`;

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;

      updateVisibility();
    };

    prevBtn?.addEventListener('click', () => {
      index += -1;
      update();
    });

    nextBtn?.addEventListener('click', () => {
      index += 1;
      update();
    });

    root.addEventListener('keydown', (e) => {
      if (window.innerWidth <= 749) return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        index += -1;
        update();
      }

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        index += 1;
        update();
      }
    });

    root.tabIndex = 0;

    const onResize = debounce(() => {
      update();
    }, 120);

    window.addEventListener('resize', onResize);
    window.addEventListener('load', update, { once: true });

    const images = root.querySelectorAll('img');
    let pending = 0;

    images.forEach((img) => {
      if (img.complete) return;
      pending += 1;
      img.addEventListener(
        'load',
        () => {
          pending -= 1;
          if (pending <= 0) update();
        },
        { once: true }
      );
    });

    update();
    initTilt(root);
  });
})();